<template>
  <form v-on:submit="save">
    <div class="card card-info">
      <div class="card-header">
        <h3 class="card-title">Payment Verification Form</h3>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <div class="card-body" >
        <div class="row">
          <div class="col-md-4">
            Session 
            <select class="form-control" v-model="filter.SemesterID">
              <option value="0">--Select Session--</option>
              <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            Degree 
            <select class="form-control" v-model="filter.DegreeID" v-on:change="loadDepartment()">
              <option value="0">--Select Degree--</option>
              <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            Department
            <select class="form-control" v-model="filter.DepartmentID" v-on:change="loadPrograms()">
              <option value="0">--Select Department--</option>
              <option v-for="item in departments" v-bind:value="item.DepartmentID">{{item.Name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            Program
            <select class="form-control" v-model="filter.ProgramID">
              <option value="0">--Select Program--</option>
              <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
            </select>
          </div>
          <div class="col-md-4">
            Name/Form #/Father Name/CNIC
            <input class="form-control" v-mask="'##########'" v-model="filter.Name" />
          </div>
          <div class="col-md-4">
            Type
            <select class="form-control" v-model="Types">
              <option value="0">--Select Type--</option>
              <option value="1">Recieved</option>
              <option value="2">Pending</option>
            </select>
          </div>
          <div class="col-md-12">
            <div class="form-group pull-right ">
              <button class="btn btn-primary float-right" type="button" style="margin-top: 20px; float:right; margin-right:15px; " v-on:click="btnSearch()">Search</button>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 10px" v-if="prospects.length > 0">
          <div class="col-md-12">
            
            <div class="table-responsive">
              <table class="table table-striped table-bordered table-color table-sm">
                <thead class="bg-info text-white">
                  <tr>
                    <th style="width: 5px; text-align: center">Sr.#</th>
                    <th style="width: 20px; text-align: center">Image</th>
                    <th style="width: 10%">Session</th>
                    <th style="width: 20%">Program</th>
                    <th style="width: 15%">Form #</th>
                    <th style="width: 20%">Name</th>
                    <th style="width: 20%">Father Name</th>
                    <th style="width: 10%">CNIC</th>
                    <th style="width: 5px; text-align: center;">Payment</th>
                    <th style="width: 25px; text-align: center;">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, ind) in prospects">
                    <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>
                    <td style="text-align: center; vertical-align: middle">
                      <img style="max-height:60px" v-bind:src="p.temp" />
                    </td>
                    <td style="vertical-align: middle">{{p.Session}}</td>
                    <td style="vertical-align: middle">
                      <span v-for="pr in p.Programs">
                        {{pr.Priority}}. {{pr.Name}}<br />
                      </span>
                    </td>
                    <td style="vertical-align: middle">{{p.FormNo}}</td>
                    <td style="vertical-align: middle">{{p.Name}}</td>
                    <td style="vertical-align: middle">{{p.FathersName}}</td>
                    <td style="vertical-align: middle">{{p.CNIC}}</td>
                    <td style="vertical-align: middle; text-align: center;">
                      <i v-if="p.PaymentReceived == true">Recieved</i>
                      <i v-else>Pending</i>
                    </td>
                    <td style="vertical-align: middle; text-align: center;">
                      <div class="btn-group-vertical">
                        <button type="button" v-if="p.Tab >= 6" class="btn btn-success" v-on:click="printChallanForm(p.ProspectStudentID)" title="Print Form"><i class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-warning" v-on:click="edit(p.ProspectStudentID)" title="Edit"><i class="fa fa-edit"></i></button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="myModal" role="dialog">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Payment Verification</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-10 col-sm-6">
                <div class="row">
                  <div class="col-md-6 col-sm-12 col-xga-12 mb-12">
                    <label>Form No</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.FormNo">
                  </div>
                  <div class="col-md-6 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Admission Category</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.AdmissionCategory">
                  </div>
                  <div class="col-md-6 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom01">Applicant Name</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.Name">
                  </div>
                  <div class="col-md-6 col-sm-12 col-xga-12 mb-12">
                    <label for="validationCustom02">Applicant Mobile *</label>
                    <input type="text" class="form-control disabled" disabled v-model="st.MobileNo">
                  </div>
                </div>
              </div>
              <div class="col-md-2 col-sm-4 col-xga-6">
                <img v-bind:src="st.temp" class="img-thumbnail" />
              </div>
            </div>

            <div class="table-responsive" style="margin-top: 8px;">
              <table class="table  table-color table-sm table-striped">
                <thead class="bg-info text-white">
                  <tr>
                    <th style="width: 10%; text-align: center">Priority</th>
                    <th>Program </th>
                    <th>Type </th>
                    <th style="width: 1px">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in  choices">
                    <td style="width: 10%; text-align: center">{{index + 1}}</td>
                    <td>
                      {{item.ProgramName}}
                    </td>
                    <td>
                      {{item.Type}}
                    </td>
                    <td style="width: 1px">{{item.Amount}}</td>
                </tbody>
              </table>
            </div>

            <div class="row">
              <div class="col-md-6">
                <label>Payment Received</label>
                <select class="form-control" v-model="st.PaymentReceived">
                  <option value="false">No</option>
                  <option value="true">Yes</option>
                </select>
              </div>
              <div class="col-md-6 text-right">
                <h3>Total: <span style="border-top: 1px solid gray; border-bottom: 1px solid gray">{{sum.toLocaleString()}}</span></h3>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <input type="submit" value="Save" class="btn btn-success " />
            <!--<button type="button" class="btn btn-success " v-on:click="save()">Save</button>-->
            <button type="button" class="btn btn-default " data-dismiss="modal">Close</button>


          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        departments: [],
        programs: [],
        selDegreeID: 0,
        semesters: [],
        degrees: [],
        filter: { SemesterID: 0, ProgramID: 0, DepartmentID: 0, DegreeID: 0, Name: '' },
        prospects: [],
        st: { AdmissionCategory: '', Name: '', ProspectStudentID: 0, EntryTestFee: 0, temp: '', PaymentReceived: false, FormNo: '' },
        choices: [],
        sum: 0,
        Types: 0
      }
    },
    created: function () {
      this.pageLoad();
    },
    mounted: function () {

    },
    methods: {
      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/prospectRecordPageLoad')
          .then(function (pl) {
            vm.semesters = pl.data.sem;
            vm.degrees = pl.data.deg;
            endReq();
          })
      },
      loadDepartment() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/loadDepartments?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID)
          .then(function (res) {
            vm.departments = res.data.lst;
            endReq();
          })
      },
      loadPrograms() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/loadProgramsProspect?semID=' + vm.filter.SemesterID + "&degID=" + vm.filter.DegreeID + "&depID=" + vm.filter.DepartmentID)
          .then(function (res) {
            vm.programs = res.data.lst;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      save(e) {


        e.preventDefault();
        var vm = this;
        startReq();
        if (vm.st.PaymentReceived == 'true')
          vm.prospects.find(x => x.ProspectStudentID == vm.st.ProspectStudentID).PaymentReceived = true;
        else
          vm.prospects.find(x => x.ProspectStudentID == vm.st.ProspectStudentID).PaymentReceived = false;
        axios.post('/api/AdmissionApi/savePaymentVerification', {
          st: vm.st
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done!");
              $('#myModal').modal('hide');
            }
            else
              toastr.error(res.data.msg);

          })
          .catch(function (err) {
            endReq();
            if (err.response) {
              var res = err.response;
              if (res.status == 401) {
                toastr.error(res.data);
              }
              else {
                for (const [key, value] of Object.entries(res.data.errors)) {
                  //console.log(`${value}`);
                  toastr.error(`${value}`);
                }
              }
            }
          })


      },
      btnSearch() {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/searchProspectStudentPaymentVerification2?types=' + Number(vm.Types) + "&semID=" + vm.filter.SemesterID +  "&degID=" + vm.filter.DegreeID + "&depID=" + vm.filter.DepartmentID + "&progID=" + vm.filter.ProgramID + "&Name=" + vm.filter.Name, {
          /*filter: vm.filter,*/
          //types: Number(vm.Types)
        })
          .then(function (res) {
            /*       var result = res.data.replace('{"d":null}', '');*/
            vm.prospects = res.data.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      edit(id) {
        var vm = this;
        //startReq();
        axios.post('/api/AdmissionApi/editProspectStudentPaymentVerification?ID=' + id)
          .then(function (res) {
            //endReq();
            vm.st = res.data.ps;
            console.log(vm.st);
            vm.choices = res.data.psc;
            vm.sum = Number(vm.st.EntryTestFee);
            for (var i = 0; i < vm.choices.length; i++) {
              vm.sum = vm.sum + Number(vm.choices[i].Amount);
            }
            $('#myModal').modal('show');

          })
          .catch(function (error) {
            console.log(error);
          })
      },
      //printAdmissionForm(id) {
      //  var vm = this;
      //  startReq();
      //  axios.post('/api/AdmissionApi/printAdmissionForm?ID=' + id)
      //    .then(function (res) {
      //      endReq();
      //      redirect_blank("../Admission/OnlineRegistrationFormPrint");
      //    })
      //    .catch(function (error) {
      //      console.log(error);
      //    })
      //},
      printChallanForm(id) {
        var vm = this;
        startReq();
        axios.post('/api/AdmissionApi/printChallanForm?ID=' + id)
          .then(function (res) {
            endReq();
            window.open(res.data.url, '_blank');
            //redirect_blank(res.data.url);
          })
          .catch(function (error) {
            console.log(error);
          })
      },
    }
  })

</script>

<style>

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/paymentVerificationForm.vue